module.exports = __webpack_public_path__ + "img/madera018.52519201.jpg";